<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>退货地址</span>
        <div class="float-right">
          <el-button v-if="shopReturnAddressManageInfo.shopReturnAddresss.length === 0" type="primary" size="small"
            @click="_openAddShopReturnAddressModal">
            <i class="el-icon-plus"></i>新增
          </el-button>
        </div>
      </div>

      <el-table :data="shopReturnAddressManageInfo.shopReturnAddresss" style="width: 100%" border>
        <el-table-column prop="addressId" label="地址ID" align="center" />
        <el-table-column prop="name" label="收货人名称" align="center" />
        <el-table-column prop="link" label="联系电话" align="center" />
        <el-table-column prop="address" label="详细地址" align="center" />
        <el-table-column prop="seq" label="排序" align="center" />
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="_openEditShopReturnAddressModel(scope.row)">修改</el-button>
            <el-button type="text" size="small" @click="_openDeleteShopReturnAddressModel(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="pagination" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-size="pageSize" layout="total, prev, pager, next"
        :total="shopReturnAddressManageInfo.total"></el-pagination>
    </el-card>

    <add-shop-return-address ref="addShopReturnAddress" @refresh="query()" />
    <edit-shop-return-address ref="editShopReturnAddress" @refresh="query()" />
    <delete-shop-return-address ref="deleteShopReturnAddress" @refresh="query()" />
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { queryShopReturnAddress } from '@/api/goods/shopReturnAddressApi'
import AddShopReturnAddress from '@/components/goods/addShopReturnAddress/addShopReturnAddress.vue'
import EditShopReturnAddress from '@/components/goods/editShopReturnAddress/editShopReturnAddress.vue'
import DeleteShopReturnAddress from '@/components/goods/deleteShopReturnAddress/deleteShopReturnAddress.vue'

export default {
  name: 'ShopReturnAddressManage',
  components: {
    AddShopReturnAddress,
    EditShopReturnAddress,
    DeleteShopReturnAddress
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      shopReturnAddressManageInfo: {
        shopReturnAddresss: [],
        total: 0,
        conditions: {
          shopId: getShopId()
        }
      }
    }
  },
  created() {
    this._listShopReturnAddresss(this.currentPage, this.pageSize)
  },
  methods: {
    query() {
      this.currentPage = 1
      this._listShopReturnAddresss(this.currentPage, this.pageSize)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._listShopReturnAddresss(val, this.pageSize)
    },
    async _listShopReturnAddresss(page, rows) {
      try {
        const params = {
          ...this.shopReturnAddressManageInfo.conditions,
          page,
          row: rows
        }
        const res = await queryShopReturnAddress(params)
        this.shopReturnAddressManageInfo.shopReturnAddresss = res.data
        this.shopReturnAddressManageInfo.total = res.total
      } catch (error) {
        console.error('获取退货地址列表失败:', error)
      }
    },
    _openAddShopReturnAddressModal() {
      this.$refs.addShopReturnAddress.open()
    },
    _openEditShopReturnAddressModel(row) {
      this.$refs.editShopReturnAddress.open(row)
    },
    _openDeleteShopReturnAddressModel(row) {
      this.$refs.deleteShopReturnAddress.open(row)
    }
  }
}
</script>

<style scoped>
.float-right {
  float: right;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>